"use client";

import { useEffect, useRef } from "react";

/** Saves focus when `open` becomes true and restores it when the overlay closes. */
export function useRestoreFocusOnClose(open: boolean): void {
  const anchorRef = useRef<HTMLElement | null>(null);

  useEffect(() => {
    if (open) {
      const el = document.activeElement;
      anchorRef.current = el instanceof HTMLElement ? el : null;
      return;
    }
    const anchor = anchorRef.current;
    anchorRef.current = null;
    if (anchor && typeof anchor.focus === "function") {
      window.requestAnimationFrame(() => {
        try {
          anchor.focus();
        } catch {
          /* element may be unmounted */
        }
      });
    }
  }, [open]);
}
